// extracted by mini-css-extract-plugin
module.exports = {"content":"content-2eafH","menu__item_selected":"menu__item_selected-3idZL","icon":"icon-16m8u"};